import * as React from 'react';
import { connect } from 'react-redux';
import * as Models from './models/index';
import * as Components from './components/index';

import MessagesView from './views/messages/index';

import './layout.big.scss';

interface StateProps {
	messages: Models.CorporateMessage[];
}
interface OwnState {
	showMessages: boolean;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	messages: state.messages.messages,
});

export default connect(mapStateToProps)(
	class Index extends React.Component<StateProps & OwnState, any> {
		render() {
			return (
				<Components.LayoutBlock className='app-host app-big full-absolute' inline fill>
					{this.props.showMessages ? (
						<Components.LayoutBlock fill className='layout-left-pane' style={{ width: '100%' }}>
							<MessagesView />
						</Components.LayoutBlock>
					) : null}
					<Components.LayoutBlock className='router' fill verticalAlign='center' align='center' style={{ width: '100%' }}>
						{this.props.children}
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
